import { getPostHogClient } from "../posthog-client";
import type { Metric, MetricType } from "./types";
import { WEB_VITALS_THRESHOLDS, PAGE_LOAD_THRESHOLD_MS } from "./types";
import { logMetric } from "./utils";

/**
 * Determines rating for Web Vitals metric
 */
export function getRating(name: MetricType, value: number): "good" | "needs-improvement" | "poor" {
  const thresholds = WEB_VITALS_THRESHOLDS[name];
  if (!thresholds) {
    return "good";
  }

  if (value <= thresholds.good) {
    return "good";
  }
  if (value <= thresholds.needsImprovement) {
    return "needs-improvement";
  }
  return "poor";
}

/**
 * Reports Web Vitals metrics for page load performance tracking.
 */
export function reportWebVitals(metric: Metric): void {
  const { name, value, rating } = metric;

  // Check if page load meets threshold (perf-001)
  if (name === "LCP") {
    const meetsThreshold = value < PAGE_LOAD_THRESHOLD_MS;
    logMetric("Page Load", {
      metric: name,
      value: `${Math.round(value)}ms`,
      threshold: `${PAGE_LOAD_THRESHOLD_MS}ms`,
      status: meetsThreshold ? "✓ PASS" : "✗ FAIL",
      rating,
    });
  } else {
    logMetric("Web Vitals", {
      metric: name,
      value: name === "CLS" ? value.toFixed(3) : `${Math.round(value)}ms`,
      rating,
    });
  }

  // Send to PostHog
  const posthog = getPostHogClient();
  if (posthog) {
    posthog.capture("web_vitals", {
      metric: name,
      value,
      rating,
      navigationType: metric.navigationType,
    });
  }
}
